module.exports = __webpack_public_path__ + "static/media/homepage_img.91cd5ff2.webp";